<template>
  <v-dialog v-model="dialog" max-width="650" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Form Unggah Berita Acara {{ type === 'revisi' ? '(Revisi)' : '' }}</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <div class="mb-1">
          <span class="grey--text">Unggah Template Berita Acara Kepala Sekolah (format file .pdf)</span>
          <span class="red--text"> *</span>
        </div>
        <v-file-input
          v-model="form.file"
          :accept="['.pdf']"
          outlined
          dense
          prepend-icon="mdi-upload"
          :placeholder="`Unggah file BA ${type === 'revisi' ? 'Revisi' : ''} sesuai template berkas yang telah diunduh`"
          persistent-hint
          hide-details
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small text @click="close">
          Batal
        </v-btn>
        <v-btn class="ma-2" color="primary" elevation="1" @click="save">
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupUnggah',
  props: {
    type: {
      type: String,
      default: 'dokumen',
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.form = {};
    },

    close() {
      this.dialog = false;
    },

    save() {
      this.$emit('save', this.form.file);
    },
  },
};
</script>
